import React from "react";
import { useSettings } from "../context/SettingsContext";
import { resolveImageUrl } from "../lib/api";

/**
 * Editorial hero with a 33vh image and a strip of edition meta at the bottom.
 * Uses a subtle dark gradient + small high-contrast pill tags so text is
 * legible on any background (white, dark, or photo).
 */
export const Hero = ({ imageKey = "hero_image", leftKey = "hero_top_left", rightKey = "hero_top_right" }) => {
  const { settings } = useSettings();
  const image = resolveImageUrl(settings[imageKey] || "");
  const left = settings[leftKey] || "";
  const right = settings[rightKey] || "";

  return (
    <header
      data-testid="hero-section"
      className="relative w-full h-[33vh] overflow-hidden border-b border-black/90 bg-zinc-100"
    >
      {image && (
        <img
          src={image}
          alt="Hero"
          className="w-full h-full object-cover"
          draggable={false}
        />
      )}

      {/* Subtle vignettes — top brightens nav, bottom darkens strip */}
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/30 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/55 to-transparent pointer-events-none" />

      <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between px-6 md:px-10 pb-3 gap-3">
        {left && (
          <span
            data-testid="hero-strip-left"
            className="font-display text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase text-white px-2.5 py-1 bg-black/65 backdrop-blur-sm border border-white/10"
          >
            {left}
          </span>
        )}
        {right && (
          <span
            data-testid="hero-strip-right"
            className="font-display text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase text-white px-2.5 py-1 bg-black/65 backdrop-blur-sm border border-white/10"
          >
            {right}
          </span>
        )}
      </div>
    </header>
  );
};

export default Hero;
